<template>
  <div class="page-wrapper">
    <div class="page-inner bg-light">
      <div class="page-content-wrapper bg-transparent m-0">
        <start-layout-navbar />

        <start-layout-body />

        <start-layout-footer />
      </div>
    </div>
  </div>
</template>

<script>
import StartLayoutNavbar from './components/layout/StartNavbar.vue';
import StartLayoutBody from './components/layout/StartBody.vue';
import StartLayoutFooter from './components/layout/StartFooter.vue';

// @vuese
// Layout niezalogowanego użytkownika
// @group Start
export default {
  components: {
    StartLayoutNavbar,
    StartLayoutBody,
    StartLayoutFooter
  }
};
</script>
